import { useHistory } from "react-router-dom";
import { useAFLColumns, useAFLRequests } from "../../../hooks";
import { withProcedureWraper } from "../../../../..";
import { Routes } from "../../../../../../../AppRoutes";
import { Box, Icon, Table, UserManual } from "../../../../../../../components";
import CreateRequestButton from "../../../../../components/CreateRequestButton";
import { AFLType } from "../../../models";

const AbsenceLetterDAD = withProcedureWraper(() => {
  const history = useHistory();

  const { columns, columns2 } = useAFLColumns();
  const { isLoading, myRequests, completedMyRequests, myRequestsNeedApproval } = useAFLRequests({
    aflType: AFLType.ApplicationForLeave,
    department: ["DAD"],
  });

  const redirectToDetailPage = (requestId: string) => {
    history.push(`${Routes.absenceLetterDADPage.path}/${requestId}`);
  };

  const redirectToCreatePage = () => {
    history.push(Routes.createAbsenceLetterDADPage.path);
  };

  return (
    <div className="pd15">
      <UserManual
        icon={<Icon.DocumentWrite />}
        title="ĐƠN XIN NGHỈ PHÉP"
        guideLink="https://drive.google.com/file/d/1cTZp3KvqCi4m31VIsQGslf47d-VANUW8/view"
      />
      <Box title="Yêu cầu đã duyệt" titleRight={<CreateRequestButton onClick={redirectToCreatePage} />}>
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={completedMyRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={myRequestsNeedApproval}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Tất cả yêu cầu">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={myRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
    </div>
  );
});

export default AbsenceLetterDAD;
